import { insertServerData } from "../insertServerData";
import { DB_SHEET_NAME } from "../../const/excel.const";
import { makeHeader } from "../header";
import { addNumFormat, addPriceFormat } from "../../utils/add-num-format";
export function makeDataSheet(workbook, data) {
    const sheet = workbook.addWorksheet(DB_SHEET_NAME);
    makeHeader(sheet);
    insertServerData(sheet, data);
    addNumFormat(sheet, `Q2`, `IFERROR(SUM(I:I), 0)`);
    addPriceFormat(sheet, `R2`, `IFERROR(SUM(M:M), 0)`);
}
